import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PupilsConstants } from '../store/pupils.constants'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getPupilsSelector } from '../selectors/pupils.selector'
import { getServiceIdSelector } from '../../../../user/selectors'
import { IPupilsState } from '../store/pupils.types'
import { getPcrIdSelector } from '../../../../home/selectors'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { setPupilsResponse } from '../store/pupils.actions'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* savePupils() {
  const pupils: IPupilsState = yield select(getPupilsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...pupils,
      },
    }

    try {
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setPupilsResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePupils() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* savePupilsSaga() {
  yield takeLatest([PupilsConstants.SAVE_PUPILS], performWithMutexHOG, savePupils)
}
